// GizmoController.ts
import { RotateGizmo, Entity, AppBase, Gizmo } from 'playcanvas';

export class GizmoController {
    app: AppBase;

    entity: Entity;

    gizmoLayer: any;

    gizmo: RotateGizmo | null = null;

    constructor(app: AppBase, entity: Entity) {
        this.app = app;
        this.entity = entity;
        this.gizmoLayer = Gizmo.createLayer(app);
    }

    update() {
        if (this.gizmo) {
            this.gizmo.update();
        }
    }

    toggle(gsplatEntity: Entity, show: boolean) {
        if (!gsplatEntity) return;

        if (show) {
            if (!this.gizmo) {
                this.gizmo = new RotateGizmo(this.entity.camera, this.gizmoLayer);
                this.gizmo.on('pointer:down', (_x, _y, meshInstance) => {
                    this.app.fire('gizmo:pointer', !!meshInstance);
                });

                this.gizmo.on('pointer:up', () => {
                    this.app.fire('gizmo:pointer', false);

                    if (this.gizmo && this.gizmo.nodes.length > 0) {
                        const targetEntity = this.gizmo.nodes[0] as Entity;
                        const rotationQuat = targetEntity.getRotation();
                        const rotationEuler = targetEntity.getEulerAngles();
                        this.app.fire('gizmo:rotationEnd', rotationQuat, rotationEuler);
                    }
                });

                this.gizmo.attach([gsplatEntity]);
            }
        } else {
            if (this.gizmo) {
                this.gizmo.detach();
                this.gizmo = null;
            }
        }
    }
}